import type { OrgEmptyStateVariant } from '../components/OrgEmptyState'

interface OrgEmptyStateInput {
  /** Organizations matching the current search across every page. */
  totalCount: number
  /** How many rows the requested page actually returned. */
  resultCount: number
  hasSearch: boolean
}

/**
 * Decide which empty state an organization list with no rows should show.
 *
 * A page past the end of the result set comes back empty with a non-zero total,
 * which is neither a first run nor a search miss. Inviting the user to create
 * their first organization there would be wrong — organizations exist, the
 * requested page just holds none of them — so it gets its own state.
 */
export const getOrgEmptyStateVariant = ({
  totalCount,
  resultCount,
  hasSearch,
}: OrgEmptyStateInput): OrgEmptyStateVariant => {
  if (totalCount > 0 && resultCount === 0) {
    return 'pageOutOfRange'
  }

  return hasSearch ? 'noSearchResults' : 'firstRun'
}
